import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    myAppraisals: [],
    total: 0,
    appraisalsById: [],
    appraisalApproval: [],
    generalSettingsTotal: null,
    tableLoading: true,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    selectedRow: null,
  },
  actions,
  mutations,
};
